// SEO Performance utilities

// Call this in App initialization
export function initializeSEO() {
  // Set up performance monitoring
  if ('PerformanceObserver' in window) {
    try {
      // Monitor Largest Contentful Paint
      const lcpObserver = new PerformanceObserver((entryList) => {
        if (import.meta.env.DEV) {
          const entries = entryList.getEntries();
          const lastEntry = entries[entries.length - 1] as PerformanceEntry & { renderTime?: number; loadTime?: number };
          console.log('LCP:', lastEntry.renderTime || lastEntry.loadTime);
        }
      });
      lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });

      // Monitor Interaction to Next Paint (INP) — replaced FID (deprecated March 2024)
      const inpObserver = new PerformanceObserver((entryList) => {
        if (import.meta.env.DEV) {
          const entries = entryList.getEntries();
          entries.forEach((entry) => {
            const eventEntry = entry as PerformanceEntry & { processingStart: number; processingEnd: number };
            const duration = eventEntry.processingEnd - eventEntry.processingStart;
            if (duration > 50) {
              console.log('INP candidate:', Math.round(entry.duration), 'ms');
            }
          });
        }
      });
      inpObserver.observe({ type: 'event', buffered: true });

      // Monitor Cumulative Layout Shift (CLS)
      let clsValue = 0;
      const clsObserver = new PerformanceObserver((entryList) => {
        for (const entry of entryList.getEntries()) {
          const layoutShift = entry as PerformanceEntry & { hadRecentInput: boolean; value: number };
          if (!layoutShift.hadRecentInput) {
            clsValue += layoutShift.value;
          }
        }
        if (import.meta.env.DEV && clsValue > 0.05) {
          console.log('CLS:', clsValue.toFixed(4));
        }
      });
      clsObserver.observe({ type: 'layout-shift', buffered: true });
    } catch (e) {
      // Observer not supported
    }
  }

}

// Note: robots.txt, sitemap.xml, and llms.txt are served as static files from public/
